import styled from 'styled-components';
import {} from './index.js';
import React from 'react';
import { getMargins, getTypographyStyles, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SEM_TYPOGRAPHY_FEEDBACK_COPY, SEM_TYPOGRAPHY_FEEDBACK_HEADLINE, SYS_BORDER_RADIUS_MD, SYS_BORDER_WIDTH_100, SYS_SPACE_FIXED_25, SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-alpha-common';
import { Icon } from '../icon/index.js';
import { TextLink } from '../text-link/index.js';
export const StyledContainer = styled.div `
  display: flex;
  flex-direction: row;
  background: ${(props) => props.theme.sys.gradient.elevation.level2.fill};
  color: ${(props) => props.theme.sem.color.feedback.foreground.text.default};
  box-shadow:
    inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
      ${(props) => props.theme.sys.color.elevation.level2.stroke},
    0px 6px 0px ${(props) => props.theme.sys.color.elevation.level2.shadowColor};
  margin: ${(props) => getMargins(props.margin)};
  border-radius: ${SYS_BORDER_RADIUS_MD};
`;
export const StyledLeftContainer = styled.div `
  padding: ${SYS_SPACE_FIXED_200};
  display: flex;
  width: 100%;
`;
export const StyledIconButtonContainer = styled.div `
  display: flex;
  padding: ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_100} 0 0;
  width: auto;
`;
export const StyledContentContainer = styled.div `
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
export const StyledTextLinkButton = styled(TextLink) `
  margin-top: ${SYS_SPACE_FIXED_200};
  align-self: start;
`;
export const StyledError = styled.span `
  margin-top: ${SYS_SPACE_FIXED_100};
  color: ${(props) => props.theme.sem.color.feedback.foreground.text.informative};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_COPY)}
`;
export const StyledTextLink = styled(TextLink) `
  margin-top: ${SYS_SPACE_FIXED_200};
  align-self: start;
`;
export const StyledTitle = styled(({ ...props }) => {
    const HtmlTag = props.tag;
    return React.createElement(HtmlTag, { ...props }, props.text);
}) `
  margin: ${SYS_SPACE_FIXED_25} 0;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_HEADLINE)}
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  margin-right: ${SYS_SPACE_FIXED_150};
  color: ${(props) => props.icon === 'break'
    ? props.theme.sem.color.feedback.foreground.icon.default
    : props.icon === 'caution'
        ? props.theme.sem.color.feedback.foreground.icon.error
        : props.icon === 'info-circle'
            ? props.theme.sem.color.feedback.foreground.icon.warning
            : props.theme.sem.color.feedback.foreground.icon.success};
`;
export const StyledUpperContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const StyledCopy = styled.span `
  &:not(:first-child) {
    margin-top: ${SYS_SPACE_FIXED_100};
  }

  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_COPY)}
`;
//# sourceMappingURL=index.styles.js.map